/**
 * Public API for Marketplace
 * This is the public API for the Marketplace service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PurchaseInternal404Response { 
    error_key?: PurchaseInternal404Response.ErrorKeyEnum;
}
export namespace PurchaseInternal404Response {
    export type ErrorKeyEnum = 'payment_method.not_found' | 'user.not_found' | 'offer.not_found' | 'promocode.not_found';
    export const ErrorKeyEnum = {
        PaymentMethodNotFound: 'payment_method.not_found' as ErrorKeyEnum,
        UserNotFound: 'user.not_found' as ErrorKeyEnum,
        OfferNotFound: 'offer.not_found' as ErrorKeyEnum,
        PromocodeNotFound: 'promocode.not_found' as ErrorKeyEnum
    };
}


